import { useCallback } from "react";
import "../../internal/features/forms/middleware.js";
import "../../internal/features/forms/reducer.js";
import { selectById, selectLoading, selectError } from "../../internal/features/forms/selectors.js";
import { useAppActions } from "../../internal/shared/lib/store/hooks/useAppActions.js";
import { useAppSelector } from "../../internal/shared/lib/store/hooks/useAppSelector.js";
function useForm({ id }) {
  const form = useAppSelector((state) => selectById(state, id));
  const loading = useAppSelector(selectLoading);
  const error = useAppSelector(selectError);
  const {
    forms: { setValues, setValue, setErrors, submitForm }
  } = useAppActions();
  const setFieldValue = useCallback(
    (fieldId, value) => {
      setValue({ formId: id, id: fieldId, value });
    },
    [id, setValue]
  );
  const setFieldsValues = useCallback(
    (fields) => {
      setValues({ formId: id, fields });
    },
    [id, setValues]
  );
  const setFieldsErrors = useCallback(
    (fieldsErrors) => {
      setErrors({ formId: id, fieldsErrors });
    },
    [id, setErrors]
  );
  return {
    data: form,
    loading,
    error,
    actions: {
      setFieldValue,
      setFieldsValues,
      setFieldsErrors,
      submitForm
    }
  };
}
export {
  useForm
};
